/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { useHookstate, ImmutableObject } from "@hookstate/core";
import { ArrowDropDown } from "@mui/icons-material";
import { ClickAwayListener, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Catalog, useCatalogState } from "../hooks/useCatalogState";
import { useInventoryState } from "../hooks/useInventoryState";
import { useCheckoutFormState } from "../hooks/useCheckoutFormState";
import { useStorefrontSettingsState } from "../hooks/useStorefrontSettingsState";
import { useThemeState } from "@/hooks/useThemeState";

export type CatalogMenuProps = {
    css?: string;
}
export const CatalogMenu: React.FC<CatalogMenuProps> = props => {
    const themeState = useThemeState();
    const catalogState = useCatalogState();
    const checkoutFormState = useCheckoutFormState();
    const storefrontSettingsState = useStorefrontSettingsState();
    const isUniversity = storefrontSettingsState.get().settings?.IsUniversity ?? false;
    const filterCatalogsByLocation = storefrontSettingsState.get().settings?.FilterCatalogsByLocation ?? false;
    let catalogs = catalogState.get().catalogs || [];
    if (filterCatalogsByLocation && !isUniversity) {
        catalogs = catalogs.filter(c => c.WarehouseId === checkoutFormState.getWarehouse()?.WarehouseId);
    }

    const inventoryState = useInventoryState();
    const navigate = useNavigate();

    const anchorElState = useHookstate<null | HTMLElement>(null);
    const open = Boolean(anchorElState.get());
    const handleClose = async (catalog?: Catalog|ImmutableObject<Catalog>) => {
        anchorElState.set(null);
        if (catalog) {
            navigate(`/inventory/${catalog.Id}`);
        }
    };

    return (<>
        <ClickAwayListener onClickAway={async e => { await handleClose(); }}>
            <div css={css`
                display: flex;
                align-items: center;`}>
                <span css={css`padding:0 0.1rem 0 0;color:${themeState.isDark() ? '#ccc' : '#777'};`}></span>
                <div
                    css={css`
                        margin: 0 0 0 .5em;
                        font-size:.8rem;
                        display:flex;
                        align-items: center;
                        cursor: pointer;
                        text-decoration: underline;
                        text-underline-offset: 2px;
                        ${props.css ?? ''};`}
                    onClick={event => {
                        anchorElState.set(event.currentTarget);
                    }}>
                    {inventoryState.get().catalog?.Name}
                    {<ArrowDropDown fontSize="small" />}
                </div>
            </div>
        </ClickAwayListener>
        <div>
        <Menu
            id="basic-menu"
            anchorEl={anchorElState.get() as HTMLButtonElement}
            open={open}
            onClose={async e => { await handleClose(); }}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}>
            {catalogs?.map((catalog, index) => (
                <MenuItem key={index} onClick={async e => await handleClose(catalog)}>{catalog.Name}</MenuItem>
            ))}
        </Menu>
        </div>
    </>);
}